<template>
    <div class="card mb-5" :class="containerClasses">
        <div class="fl-te-c" :class="{'pb-3': title !=='' || $slots.buttons}">
            <div v-if=" $slots.title || title !==''" :class="{'w-100p': !$slots.buttons}">
                <slot name="title">
                    <h4 v-html="title" v-if="title!==''"></h4>
                </slot>
            </div>

            <div v-if="$slots.buttons" :class="{'fl-x-br w-100p': !$slots.title && title === ''}">
                <slot name="buttons"></slot>
            </div>
        </div>

        <div class="ld-over" :class="[{'running': dataLoading}]">

            <div class="ld ld-ring ld-spin" v-if="dataLoading"></div>

            <div class="fl-te-c" :class="{'mb-2 mt-2': showCurrentPageDataIndexes || showSearchBox}">
                <div class="fl-x">
                    <form-input size="sm" :placeholder="searchPlaceholder" v-model="search" v-show="showSearchBox"/>
                    <div class="ml-3">
                        <slot name="additional-filters"></slot>
                    </div>
                </div>
                <div v-if="showCurrentPageDataIndexes">
                    <span class="text-muted text-small">{{ from }}-{{ to }} of {{ total }}</span>
                </div>
            </div>

            <div v-show="error">
                <slot name="error">
                    <div class="bg-danger p-3">
                        <error-icon/>
                        Loading Data Failed.
                    </div>
                </slot>
            </div>

            <vuetable ref="vuetable" class="order-with-arrow" pagination-path
                      v-bind="tableProperties" @vuetable:pagination-data="onPaginationData"
                      v-on="tableListeners" v-show="!error">
                <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
                    <slot :name="slot" v-bind="scope"/>
                </template>
            </vuetable>

            <vuetable-pagination-bootstrap
                :next-icon="nextIcon"
                :prev-icon="prevIcon"
                :first-icon="firstIcon"
                :last-icon="lastIcon"
                v-show="canShowPagination"
                class="mt-4"
                ref="pagination"
                @vuetable-pagination:change-page="onChangePage" v-if="paginationDesign ==='design-1'"/>
            <vuetable-pagination-design2
                :next-icon="nextIcon"
                :prev-icon="prevIcon"
                :first-icon="firstIcon"
                :last-icon="lastIcon"
                :prev-next-button-design="paginationPrevNextButtonDesign"
                :prev-next-button-classes="paginationPrevNextButtonClasses"
                :container-classes="paginationContainerClasses"
                v-show="canShowPagination"
                class="mt-4"
                ref="pagination"
                @vuetable-pagination:change-page="onChangePage"
                v-else-if="paginationDesign ==='design-2'"
            />
            <vuetable-pagination-design3
                :next-icon="nextIcon"
                :prev-icon="prevIcon"
                :first-icon="firstIcon"
                :last-icon="lastIcon"
                :prev-next-button-design="paginationPrevNextButtonDesign"
                :prev-next-button-classes="paginationPrevNextButtonClasses"
                :container-classes="paginationContainerClasses"
                v-show="canShowPagination"
                class="mt-4"
                ref="pagination"
                @vuetable-pagination:change-page="onChangePage"
                v-else-if="paginationDesign ==='design-3'"/>
                <!--                <template #prev-button-inner-elems v-if="">-->
                <!--                    <slot name="pagination-prev-button-inner-elems"></slot>-->
                <!--                </template>-->
                <!--                <template #next-button-inner-elems>-->
                <!--                    <slot name="pagination-next-button-inner-elems"></slot>-->
                <!--                </template>-->

        </div>

        <slot name="footer"></slot>
    </div>
</template>

<script>
import VueTableComponentMixin from '../tables/VueTableComponentMixin';

export default {
    name    : 'vue-table-card',
    extends : VueTableComponentMixin,
    props   : {
        title : {
            type    : String,
            default : ''
        }
    }
};
</script>
